// extracted by mini-css-extract-plugin
export default {"home_section":"Home_home_section__fLImK"};